<!-- RESPONSIVE PART -->

@if (isMobileWidth()) {
<ng-container [ngTemplateOutlet]="mobile" [ngTemplateOutletContext]="{ $implicit: img160() }"></ng-container>
} @else {
<ng-container [ngTemplateOutlet]="desktop" [ngTemplateOutletContext]="{ $implicit: img159() }"></ng-container>
}
<!-- MOBILE -->
<ng-template #mobile let-picture>
  <div class="main-content-full-width">
    <div class="d-flex flex-column justify-content-end bg-dark">
      <img alt="" [src]="picture" class="ecm-megapush-img ecm-megapush-img-mobile-height" />
      <div class="p-1">
        <h4 class="h3 mb-0 text-white p-0" [innerHTML]="title() | sanitizeHtml"></h4>
        <p class="text-white p-0 pt-1" [innerHTML]="text() | sanitizeHtml"></p>
        <a
          ecmPushTracker
          [pdb-zid]="zid"
          [pdb-sc]="'adv'"
          [pdb-idc]="trackingDatas()?.cappingTracking?.code"
          [pdb-ta]="trackingDatas()?.cappingTracking?.advTracker"
          [pdb-vi]="img160()"
          [href]="hrefWeb()"
          (click)="openLink();false"
          [ecmDisabledAction]="isDisabledEclairLink"
          class="o-link-arrow o-link-reverse my-1"
          data-e2e="megapush-link"
        >
          {{urlLabel()}}
        </a>
        @if (text2()) {
        <p class="small text-white mb-0" [innerHTML]="text2() | sanitizeHtml"></p>
        }
      </div>
    </div>
  </div>
</ng-template>
<!-- DESKTOP & LARGE CONTENT -->
<ng-template #desktop let-picture>
  <div class="main-content-full-width px-0 bg-dark mb-2">
    <div class="d-flex justify-content-between">
      <div class="ecm-megapush-layout">
        <div class="mx-md-0 pr-md-1 py-2">
          <h4 class="mb-0 ecm-megapush-item-pb-25 text-white" [innerHTML]="title() | sanitizeHtml"></h4>
          <p class="text-white lead p-0" [innerHTML]="text() | sanitizeHtml"></p>
          <a
            ecmPushTracker
            [pdb-zid]="zid"
            [pdb-sc]="'adv'"
            [pdb-idc]="trackingDatas()?.cappingTracking?.code"
            [pdb-ta]="trackingDatas()?.cappingTracking?.advTracker"
            [pdb-vi]="img159()"
            [href]="hrefWeb()"
            (click)="openLink();(false)"
            [ecmDisabledAction]="isDisabledEclairLink"
            data-e2e="megapush-link"
            class="btn btn-secondary btn-inverse my-1 mb-lg-0"
            >{{urlLabel()}}</a
          >
          @if (text2()) {
          <p class="small text-mw p-0 mt-2 mb-0" [innerHTML]="text2() | sanitizeHtml"></p>
          }
        </div>
      </div>
      <div class="align-content-start">
        <img alt="" class="ecm-megapush-img ecm-megapush-img-desktop" [src]="picture" />
      </div>
    </div>
  </div>
</ng-template>
